import React from "react";
import {
  Route,
  BrowserRouter as Router
} from "react-router-dom";

// import PrivateRoute from "./PrivateRoute";
import { CheckCircleOutlined } from '@ant-design/icons';
import { changePwd, createAccount } from "@axios/api.account";
import { RootStoreModel } from "@redux/reducers";
import { ConfigProvider, Form, FormInstance, Input, Modal, Row, Select, Spin, notification } from 'antd';
import Checkbox from "antd/lib/checkbox/Checkbox";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import {
  MSALObjLogin
} from "./auth/authInstance";
import HomePage from "./home/home";
import { ForgetPwd } from "./pages/forgetpwd";
import { HelpFAQ } from "./pages/help/helpFAQ";
import IndexPage from "./pages/index";
import ContactPage from "./pages/contact";
import { Login } from "./pages/login";
import RedirectPage from "./pages/redirect";
import RefreshPage from "./pages/refresh";
import { EmailRegister } from "./pages/register";
import TenantPage from "./pages/tenantPage";
import { Trial } from "./pages/trial/trial";
import { CustomLogin } from "./pages/customLogin";

import PrivateRoute from "./privateRoute";
import {
  ChangePwdShow,
  FetchedLoding,
  FetchingAccount,
  FetchingOrgsTree,
  SwitchMenu,
  UpdateLogStatus,
  UpdateRegisShow
} from "./redux/actions";
import Store from "./redux/store";
const { Item } = Form;
interface propsModel extends RouteComponentProps<any, any, any> {
  // FetchingCSPsAction: any;
  // GraphApplicatonsFetching: any;
  // timeStamp: number;
  loginType: number,
  regisShow: boolean,
  contentLoading: boolean,
  account: any,
  tokenSuccess: boolean,
  changePwdShow: boolean,
}
interface stateModel {
  timer: NodeJS.Timeout | '',
  loading: boolean,
  checkedAgreement: boolean
}
const mapStateToProps = (state: RootStoreModel) => {
  return {
    loginType: state.userState.loginType,
    regisShow: state.userState.regisShow,
    contentLoading: state.userState.isLoding,
    account: state.userState.account,
    tokenSuccess: state.userState.tokenSuccess,
    changePwdShow: state.userState.changePwdShow
  };
};
const getLocalTime = (ns: number) => {
  return new Date(ns * 1000);
}

class App extends React.Component<propsModel, stateModel> {
  constructor(props: propsModel) {
    super(props);
    this.state = {
      loading: false,
      timer: '',
      checkedAgreement: false
    }
  }
  // init(){
  //     this.logOutTimer();
  //     Store.dispatch(FetchingOrgsTree());
  //     Store.dispatch(FetchingAccount());
  //   }
  formRef = React.createRef<FormInstance>();
  formPwdRef = React.createRef<FormInstance>();
  componentDidMount() {
    var jt = localStorage.getItem('jt');
    if(jt)
      {
        Store.dispatch(UpdateLogStatus(true));
        //Store.dispatch(UserLoginAction(res));
        Store.dispatch(FetchingAccount());
        if (this.props.tokenSuccess) {
          Store.dispatch(FetchingOrgsTree());
        }
        if(window.location.pathname == '/login')
          window.location.href='/home/index';
      }
      else
      {
        if(window.location.pathname.startsWith('/home'))
            window.location.href='/login';
        Store.dispatch(FetchedLoding(false));
      }
    var menuKey = localStorage.getItem('menuKey');
    if(menuKey){
      Store.dispatch(SwitchMenu(menuKey));
    }
  }
  // componentDidMount() {
  //   var that = this;
  //   GetAccount().then(res => {
  //     this.logOutTimer();
  //     var exdate = getLocalTime(res.expires_at)

  //     var nowDate = new Date()
  //     console.log("过期时间", exdate, nowDate)
  //     if (exdate <= nowDate) {
  //       MSALObjLogout();
  //     } else {
  //       Store.dispatch(UpdateLogStatus(true));
  //       Store.dispatch(UserLoginAction(res));
  //       Store.dispatch(FetchingAccount());
  //       if (this.props.tokenSuccess) {
  //         Store.dispatch(FetchingOrgsTree());
  //       }
  //     }


  //   }).catch(error => {
  //     Store.dispatch(FetchedLoding(false));
  //   })
  // }
  componentDidUpdate(prevProps: propsModel) {
    if (this.props.tokenSuccess != prevProps.tokenSuccess) {
      Store.dispatch(FetchingOrgsTree());
    }
  }

  showConfirm() {
    Modal.warning({
      title: "系统提示",
      content: "登录已过期，请重新登录！",
      okText: "登录",
      onOk: () => {
        MSALObjLogin();
      },
    });
  }

  logOutTimer() {
    const ms = 50 * 60 * 1000;
    const t = process.env.REACT_APP_MSAL_EXPIRED_TIME || '';
    if (this.state.timer) {
      clearTimeout(this.state.timer);
    }
    const timer: NodeJS.Timeout = setTimeout((i) => {
      if (this.state.timer) {
        this.showConfirm();
        clearTimeout(this.state.timer);
      }
    }, t ? Number(t) : ms);
    this.setState({ timer });
  }

  createAccountClick() {
    const { loginType } = this.props;
    if (loginType == 2) {
      //MSALObjLogin();
      window.location.href = "/home/index";
    } else if (loginType == 1) {
      if(!this.state.checkedAgreement ){
        notification.error({message:"请先勾选用户协议"})
        return;
      }
      this.setState({ loading: true });
      this.formRef.current?.validateFields().then((res) => {
        //const { version, name, email, phoneNumber, company } = res;
        createAccount(res).then(
          () => {
            notification.success({ message: "提交成功！正在审核中" });
            this.setState({ loading: false });
            Store.dispatch(FetchingAccount());
          },
          () => this.setState({ loading: false })
        );
      })
    } else if (loginType == 3) {
      this.setState({ loading: true });
      this.formRef.current?.validateFields().then((res) => {
        //const { version, name, email, phoneNumber, company } = res;
        createAccount(res).then(
          () => {
            notification.success({ message: "修改成功" });
            this.setState({ loading: false });
            Store.dispatch(FetchingAccount());
            Store.dispatch(UpdateRegisShow(false));
          },
          () => this.setState({ loading: false })
        );
      })
    }
  }
  changePwd() {
    this.setState({ loading: true });
    this.formPwdRef.current?.validateFields().then((res) => {
      changePwd(res).then(
        () => {
          notification.success({ message: "修改成功" });
          this.setState({ loading: false });
          Store.dispatch(FetchingAccount());
          Store.dispatch(ChangePwdShow(false));
        },
        () => this.setState({ loading: false })
      );
    })
  }
  render() {
    const { loading, checkedAgreement } = this.state;
    const { loginType, regisShow, contentLoading, changePwdShow } = this.props;
    return (
      (<ConfigProvider theme={{
        token: {
          colorPrimary: '#46586E',        // 主色
          colorLink: '#46586E',        // 主色
          // colorInfo: '#46586E',           // info 类型也用主色
          // borderRadius: 8,                // 圆角
          // fontSize: 14,                   // 字号
        },
        components: {
        },
      }} 
      direction="ltr">
        <Spin spinning={contentLoading} tip="Loading...">
          <Router>
            <PrivateRoute path="/home" component={HomePage}></PrivateRoute>
            {/* <Route path="/home" component={HomePage}></Route> */}
            <Route path="/redirect" component={RedirectPage}></Route>
            <Route path="/refresh" component={RefreshPage}></Route>
            <Route path="/" exact component={IndexPage}></Route>
            <Route path="/tenant" exact component={TenantPage}></Route>
            <Route path="/helpFAG" exact component={HelpFAQ}></Route>
            <Route path="/trial" exact component={Trial}></Route>
            <Route path="/login" exact component={Login}></Route>
            <Route path="/register" exact component={EmailRegister}></Route>
            <Route path="/forgetpwd" exact component={ForgetPwd}></Route>
            <Route path="/contactus" exact component={ContactPage}></Route>
            <Route path="/customLogin" exact component={CustomLogin}></Route>
            {/* <Route path="*" component={NotFoundPage}>
            <Redirect to="/home/overview"></Redirect>
          </Route> */}
          </Router>
        </Spin>
        <Modal
          confirmLoading={loading}
          maskClosable={false}
          forceRender={true}
          open={regisShow}
          destroyOnClose={true}
          title={loginType == 1 ? "注册" : (loginType == 2 ? "审核" : "修改")}

          width={"650px"}
          onOk={() => { this.createAccountClick(); }}
          onCancel={() => {
            Store.dispatch(UpdateRegisShow(false));
            // if(loginType==2){
            //   notification.error({ message: "正在审核中" });
            // }else if(loginType==1){
            //   notification.error({ message: "请先补充资料" });
            // }

          }}>
          {(loginType == 1 || loginType == 3) && (
            <>
              <Form
                labelCol={{ span: 6 }}
                ref={this.formRef}
                layout="vertical"
                initialValues={this.props.account}
                onFinishFailed={() => { }}
              >

                <Item label="版本" name="version" rules={[{ required: true }]}>
                  <Select>
                    <Select.Option value="Basic">基础版</Select.Option>
                    <Select.Option value="Standard">标准版</Select.Option>
                    <Select.Option value="Advanced">高级版</Select.Option>
                    <Select.Option value="Customized">定制版</Select.Option>
                    <Select.Option value="Leased">租赁版</Select.Option>
                  </Select>
                </Item>

                <Item label="姓名" name="name" rules={[{ required: true }]}>
                  <Input />
                </Item>

                <Item label="邮箱" name="email" rules={[{ required: true }]}>
                  <Input type="email" />
                </Item>

                <Item
                  label="手机号码"
                  
                  name="phoneNumber"
                  rules={[{ required: true }]}
                >
                  <Input type="tel" />
                </Item>

                <Item
                  label="公司名称"
                  name="company"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Item>

              </Form>
              <p className="ft-12"><Checkbox value={checkedAgreement} onChange={(e) => {
                  console.log(e);
                 this.setState({ checkedAgreement: e.target.checked }) }}></Checkbox>&nbsp;&nbsp;已阅读并同意以下协议
                <a
                  target="blank"
                  href="https://bcssstorage.blob.core.chinacloudapi.cn/docs/MDM/%E8%93%9D%E4%BA%91%E6%95%B0%E5%AD%97%E8%B5%84%E4%BA%A7%E5%B9%B3%E5%8F%B0%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE.pdf"
                >《使用条款》</a>和<a
                  target="blank"
                  href="https://bcssstorage.blob.core.chinacloudapi.cn/docs/MDM/%E9%9A%90%E7%A7%81%E5%A3%B0%E6%98%8E.pdf"
                >《隐私申明》</a>
              </p>
            </>
          )}
          {loginType == 2 && (
            <div>
              <Row justify="center">
                <CheckCircleOutlined style={{ fontSize: '40px', color: '#1AFA29' }} />
              </Row>
              <Row justify="center" style={{ marginTop: 16 }}>
                <h2>待审核</h2>

              </Row>
              <Row justify="center" style={{ marginTop: 16 }}>
                您的注册信息已提交,请耐心等待,如有疑问请联系mdmops@oe.21vianet.com
              </Row>
            </div>


          )}
        </Modal>
        <Modal
          confirmLoading={loading}
          maskClosable={false}
          forceRender={true}
          open={changePwdShow}
          destroyOnClose={true}
          title={"修改密码"}

          width={"650px"}
          onOk={() => { this.changePwd(); }}
          onCancel={() => {
            Store.dispatch(ChangePwdShow(false));
            // if(loginType==2){
            //   notification.error({ message: "正在审核中" });
            // }else if(loginType==1){
            //   notification.error({ message: "请先补充资料" });
            // }

          }}>
            <Form
              ref={this.formPwdRef}
              name="basic"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              //style={{ maxWidth: 600 }}
              autoComplete="off"
              >
                <Form.Item
                  label="密码"
                  name="password"
                  rules={[
                    { 
                        required: true 
                    },
                    {
                        // pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$'),
                        //pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$'),
                        pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[~`·!@#$%^&*()<>?,.:;_+/、，。：；？！（）【】《》-]).{8,}$'),
                        // message: 'Password must contain at least one lowercase, one uppercase, and one special character, and be at least 8 characters long.',
                        message: '密码必须包含大小写字母和特殊字符，且长度至少为8',
                    }]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name="confirm"
                  label="密码确认"
                  dependencies={['password']}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password!',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('The two passwords that you entered do not match!'));
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
              </Form>
        </Modal>
      </ConfigProvider>)
    );
  }
}

export default connect(mapStateToProps, {
  // FetchingOrgsTree
  // FetchingCSPsAction,
  // GraphApplicatonsFetching,
})(App);
